import { Component, OnInit } from '@angular/core';
import { Validators, FormControl, FormGroup } from '@angular/forms';
import { NewmemberService } from '../../services/newmember.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/api';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-memberrevoke',
  templateUrl: './memberrevoke.component.html',
  styleUrls: ['./memberrevoke.component.css'],
  providers: [DialogService]
})
export class MemberRevokeComponent implements OnInit {

  constructor(private messageService: MessageService, public nms: NewmemberService, public config: DynamicDialogConfig, public ref: DynamicDialogRef, public confirmationService: ConfirmationService) { }
  memberRevokeForm: FormGroup;
  uploadedFiles: any = [];
  memberRevokeFormValid: boolean = true;

  ngOnInit() {
    this.memberRevokeForm = new FormGroup({
      reason: new FormControl('', Validators.compose([
        Validators.required
      ])),
      status: new FormControl('', Validators.compose([
        Validators.required
      ])),
    });
  }

  ustatusUpdate(event, group, type) {
    if (!this.uploadedFiles[group]) {
      this.uploadedFiles[group] = [];
      this.uploadedFiles[group].push({ "ustatus": event, "documentType": type });
    } else {
      let check = 0;
      for (let list of this.uploadedFiles[group]) {
        if (list.documentType == type) {
          check = 1;
          list.ustatus = event;
        }
      }
      if (check == 0) {
        this.uploadedFiles[group].push({ "ustatus": event, "documentType": type });
      }
    }
  }

  updateUploadstatus(event, group, type) {
    if (!this.uploadedFiles[group]) {
      this.uploadedFiles[group] = [];
      this.uploadedFiles[group].push({ "documentId": event.documentId, "documentType": type });
    } else {
      let done = 0;
      for (let list of this.uploadedFiles[group]) {
        if (list.documentType == type) {
          list.documentId = event.documentId;
          done = 1;
        }
      }
      if (done == 0) {
        this.uploadedFiles[group].push({ "documentId": event.documentId, "documentType": type });
      }
    }
  }

  revokeMember() {
    if (this.uploadedFiles.cardHolderDocumentsParams) {
      for (let list of this.uploadedFiles.cardHolderDocumentsParams) {
        if (!list.ustatus) {
          this.memberRevokeFormValid = false;
          this.messageService.add({ severity: 'info', summary: 'Member Revoke', detail: "Upload Request Letter" });
         return;
        }
      }
    } else {
      return;
    }

    if (this.memberRevokeForm.valid && this.uploadedFiles.cardHolderDocumentsParams.length != 0) {
      this.confirmationService.confirm({
        message: "Membership will be revoked?",
        acceptLabel: 'Ok',
        rejectLabel: 'Cancel',
        accept: () => {
          this.memberRevokeFormValid = true;
          let data: any = this.memberRevokeForm.value;
          data.supportingDocuments = this.uploadedFiles.cardHolderDocumentsParams[0];
          data.revokeBy = this.config.data.revokeBy;
          this.nms.revokeMember(this.memberRevokeForm.value).subscribe((res: any) => {
            if (res.code == "SUCCESS") {
              this.ref.close(true);
            }
          }, err => {
            console.error('ERROR', err);
          });
        }
      });
    } else {
      this.memberRevokeFormValid = false;
    }
  }
}
